export const filterApiConstants = {
    "Fruits & Vegetables": "Fruits & Vegetables",
    "Dairy, Eggs & Cheese": "Dairy, Eggs & Cheese",
    "Bread & Bakery": "Bread & Bakery",
    "Meat & Seafood": "Meat & Seafood",
    "Deli": "Deli",
    "Breakfast & Cereal": "Breakfast & Cereal",
    "Canned Goods & Soups": "Canned Goods & Soups",
    "Condiments, Spice & Bake": "Condiments, Spices & Bake",
    "Cookies, Snacks & Candy" : "Cookies, Snacks & Candy",
    "Grains, Pasta & Sides": "Grains, Pasta & Sides",
    "International Cuisine": "International Cuisine",
    "Beverages": "Beverages",
    "Wine, Beer & Spirits" : "Wine, Beer & Spirits",
    "Frozen Foods": "Frozen Foods",
    "Baby Care": "Baby Care",
    "Paper, Cleaning & Home": "Paper, Cleaning & Home",
    "Personal Care & Health": "Personal Care & Health",
    "Pet Care": "Pet Care",
    "Flowers, Cards, Occasion": "Flowers & Decor",
    "Special Offers": "Special Offers"
};
